import { AStockData, DailyRecord, ImportResult } from '@/types/sector';

const BASE = '/api';

/** 统一请求封装 */
async function request<T>(input: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${input}`, {
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const text = await res.text();
  let json: unknown;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    throw new ApiError('PARSE_ERROR', `响应解析失败 (${res.status})`);
  }
  if (!res.ok) {
    const err = json as { error?: string } | null;
    throw new ApiError('HTTP_ERROR', err?.error ?? `请求失败 (${res.status})`);
  }
  return json as T;
}

export class ApiError extends Error {
  constructor(public code: string, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export const api = {
  /** 获取全部数据 */
  getAll: () => request<AStockData>('/data'),

  /** 新增或更新某日数据 */
  upsert: (record: DailyRecord) =>
    request<{ data: AStockData }>('/data', {
      method: 'POST',
      body: JSON.stringify(record),
    }),

  /** 删除指定日期 */
  deleteDate: (date: string) =>
    request<{ data: AStockData }>(`/data?date=${encodeURIComponent(date)}`, {
      method: 'DELETE',
    }),

  /** 清空全部 */
  clearAll: () =>
    request<{ data: AStockData }>('/data', { method: 'DELETE' }),

  /** 导入 CSV */
  import: async (file: File): Promise<ImportResult> => {
    const form = new FormData();
    form.append('file', file);
    const res = await fetch(`${BASE}/import`, { method: 'POST', body: form });
    const json = await res.json();
    if (!res.ok) {
      throw new ApiError('IMPORT_ERROR', json.error ?? '导入失败');
    }
    return json as ImportResult;
  },

  /** 导出 CSV（触发浏览器下载） */
  exportUrl: () => `${BASE}/export`,
};
